<template>
  <div id="footer">
    <div class="footer-section">
      <h3 id="footer-logo">rebar</h3>
    </div>
    <div class="footer-section" id="sitemap">
      <div class="link-column">
        <router-link tag="b" to="/home/data">Data</router-link>        
        <router-link tag="a" to="/data">Browse</router-link>
      </div>
      <div class="link-column">
        <b>Models</b>
        <router-link tag="a" to="/model">Browse</router-link>
      </div>
    </div>
    <div class="footer-section" id="share">
      <a href="https://twitter.com/RebarModels"><img src="@/assets/icons/Twitter.svg" height="26"/>@RebarModels</a>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Footer',
}
</script>


<style scoped>
#footer {
  margin-top: 30px;
  padding-bottom: 30px;
  background: #C0CCD7;
  display: flex;
  border-top: 1px black solid;
  border-bottom: 1px black solid;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: inherit;
}

.footer-section {
  padding-top: 20px;
}

#sitemap {
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  width: 40%;
}
#sitemap a {
  color: black;
  text-decoration: none;
  padding: 2px 0;
}

.link-column {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  padding-top: 0;
}

#share {
  height: 30px;
}
#share a {
  color: black;
  text-decoration: none;
  font-weight: 600;
  display: flex;
  align-items: center;
}

#footer-logo {
  margin: 0;
  padding: 0;
}
#copyright {
  font-size: .8em;
}

@media only screen and (max-width: 600px) {
  #footer {
    flex-flow: column nowrap;
    align-items: center;
  }
  .link-column {
    padding: 20px;
  }
}
</style>